export const REMEMBER_ME = "ts_auth_remember_me";
export const COOKIE_AUTH_TYPE = "";
